import React from 'react';

interface NamedEntityIconV2Props {
  style?: React.CSSProperties;
}

const NamedEntityIconV2: React.FC<NamedEntityIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/named-entity.png" />;
};

export default NamedEntityIconV2;
